import type { ButtonHTMLAttributes } from 'react';
import styles from './SubmitButton.module.css';

export interface SubmitButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  label: string;
  isProcessing?: boolean;
  processingLabel?: string;
  /** 'primary' = gradient (default), 'outline' = bordered ActionButton style */
  variant?: 'primary' | 'outline';
  /** Arrow direction — 'forward' (default, points right) or 'back' (points left) */
  direction?: 'forward' | 'back';
}

export const SubmitButton = ({
  label,
  isProcessing = false,
  processingLabel,
  disabled = false,
  variant = 'primary',
  direction = 'forward',
  className,
  ...rest
}: SubmitButtonProps) => {
  const isDisabled = disabled || isProcessing;
  const variantClass = variant === 'outline' ? styles.outline : '';
  const directionClass = direction === 'back' ? styles.back : '';

  return (
    <button
      className={`${styles.button} ${variantClass} ${directionClass} ${isDisabled ? styles.disabled : ''} ${className || ''}`}
      disabled={isDisabled}
      {...rest}
    >
      {isProcessing ? (
        <>
          <span className={styles.spinner} />
          <span>{processingLabel || label}</span>
        </>
      ) : (
        <>
          <span className={styles.arrow}>
            <svg width="40" height="14" viewBox="0 0 50 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {direction === 'back' ? (
                <path d="M48 12H6M13 5l-7 7 7 7" />
              ) : (
                <path d="M2 12h42M37 5l7 7-7 7" />
              )}
            </svg>
          </span>
          <span className={styles.label}>{label}</span>
        </>
      )}
    </button>
  );
};

export default SubmitButton;
